import { render, staticRenderFns } from "./GstReprintDetail.vue?vue&type=template&id=50a6e7ce&scoped=true"
import script from "./GstReprintDetail.vue?vue&type=script&lang=js"
export * from "./GstReprintDetail.vue?vue&type=script&lang=js"
import style0 from "./GstReprintDetail.vue?vue&type=style&index=0&id=50a6e7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a6e7ce",
  null
  
)

export default component.exports